import { Component, OnInit } from '@angular/core';
import { EvaluationTrackingSearchHandler } from './evaluation-tracking.handler';
import { CompensationService } from '../services/compensation.service';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { Router } from '@angular/router';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'sym-evaluation-tracking',
  templateUrl: './evaluation-tracking.component.html',
  styleUrls: ['./evaluation-tracking.component.scss'],
})
export class EvaluationTrackingSearchComponent extends EvaluationTrackingSearchHandler {
  constructor(
    public service: CompensationService,
    public headerService: HeaderService,
    public router: Router,
    public settingService: SettingService,
    public route: ActivatedRoute
  ) {
    super(service, headerService, router, settingService, route);
  }

  ngOnInit() {
    super.ngOnInit();
  }
}
